import { useAbility } from '@casl/react';
import { AbilityContext } from './abilitiesProvider/abilitiesProvider';

export const useAppAbility = () => useAbility(AbilityContext);
